import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CompanyProduct } from 'src/app/core/models/companies.models';
import { Product } from 'src/app/core/models/products.models';

@Component({
  selector: 'craft-product-logo',
  template: '<img class="product-logo" [src]="logoUrl ? (logoUrl | thumb:size) : defaultUrl" alt="Product logo">',
  styleUrls: ['./craft-product-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftProductLogoComponent {
  @Input() public product: Product | CompanyProduct;
  @Input() public iconName = 'default';
  @Input() public size = 45;
  @Input() public useKey?: string;

  constructor() {}

  public get defaultUrl() {
    return `assets/img/${this.iconName}-product.svg`;
  }

  public get logoUrl() {
    if (this.useKey) {
      return (this.product as any)[this.useKey];
    }

    if (this.product.portalFileId) {
      return this.product.portalFileId;
    }

    if (this.product.productFile) {
      return this.product.productFile;
    }

    return '';
  }
}
